/* tslint:disable */
/* eslint-disable */
/**
 * Gallaudet
 * A set of APIs to allow seamless integration of the NUSA Roblox game
with Google Classrooms.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated.
 * Do not edit the class manually.
 */
import { exists, mapValues } from './model-utils';
import type { AssetUploadCompletionPayload } from './AssetUploadCompletionPayload';
import {
    AssetUploadCompletionPayloadFromJSON,
    AssetUploadCompletionPayloadFromJSONTyped,
    AssetUploadCompletionPayloadToJSON,
    instanceOfAssetUploadCompletionPayload,
} from './AssetUploadCompletionPayload';

/**
 * 
 * @export
 * @interface CompleteAssetUploadRequestContent
 */
export interface CompleteAssetUploadRequestContent {
    /**
     * 
     * @type {AssetUploadCompletionPayload}
     * @memberof CompleteAssetUploadRequestContent
     */
    completion: AssetUploadCompletionPayload;
}


/**
 * Check if a given object implements the CompleteAssetUploadRequestContent interface.
 */
export function instanceOfCompleteAssetUploadRequestContent(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "completion" in value;
    return isInstance;
}

export function CompleteAssetUploadRequestContentFromJSON(json: any): CompleteAssetUploadRequestContent {
    return CompleteAssetUploadRequestContentFromJSONTyped(json, false);
}

export function CompleteAssetUploadRequestContentFromJSONTyped(json: any, ignoreDiscriminator: boolean): CompleteAssetUploadRequestContent {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {

        'completion': AssetUploadCompletionPayloadFromJSON(json['completion']),
    };
}

export function CompleteAssetUploadRequestContentToJSON(value?: CompleteAssetUploadRequestContent | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {

        'completion': AssetUploadCompletionPayloadToJSON(value.completion),
    };
}

